import { render, staticRenderFns } from "./MarkTestExamAi.vue?vue&type=template&id=ca0f7fa4&scoped=true"
import script from "./MarkTestExamAi.vue?vue&type=script&lang=js"
export * from "./MarkTestExamAi.vue?vue&type=script&lang=js"
import style0 from "./MarkTestExamAi.vue?vue&type=style&index=0&id=ca0f7fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f7fa4",
  null
  
)

export default component.exports